import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AccountTypeSelection from './AccountTypeSelection';
import RegisterForm from './RegisterForm';
import VerifyOTP from './VerifyOTP';
import PendingApproval from './PendingApproval';

const Register: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AccountTypeSelection />} />
      <Route path="/form" element={<RegisterForm />} />
      <Route path="/verify" element={<VerifyOTP />} />
      <Route path="/pending" element={<PendingApproval />} />
      <Route path="*" element={<Navigate to="/register" replace />} />
    </Routes>
  );
};

export default Register;
